import service from '..';

// 获取考试列表
export const getExamList = (params: GetExamListParams) =>
  service.get<BackendDataWithPage<Exam>>('/teacher/mana/exam/list', params);

// 考试-创建考试
export const apiAddExam = (params: ExamFormDefine) => service.postJSON('/edu/mana/exam', params);

// 考试-修改考试
export const apiEditExam = (params: ExamFormDefine) => service.putJSON('/edu/mana/exam', params);

// 考试-删除考试
export const apiRemoveExam = (id: number) => service.del<boolean>(`/edu/mana/exam/${id}`);

// 考试-考试详情
export const apiExamDetail = (id: number) => service.get<Exam>(`/edu/mana/exam/${id}`);

// 获取考试科目信息
export const getExamCourseList = (id: ID) =>
  service.get<ExamCours[]>(`/teacher/mana/exam/examcourseinfo/${id}`);

// 归档
export const examArchive = (id: ID) =>
  service.put(`/edu/mana/exam/archive/${id}`);

// 学习导入开关
export const switchSchoolImport = (params: SwitchSchoolImportParams) =>
  service.put('/edu/mana/exam/schoolimportchannel', params);


// 考试-创建考试-预测
export const examCreatePreCheck = (gradeDcode: string, excludeId?: number) => service.get<boolean>('/edu/mana/exam/createprecheck', {gradeDcode, excludeId});

// 考试-简单列表
export const apiExamSimple = (params?: Partial<GetExamListParams>) => service.get<BackendDataWithPage<Exam>>('/teacher/mana/exam/simplelist', params);
